import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { CheckCircle2 } from 'lucide-react';
export const ProductReveal = () => {
  return <Section background="celeste" className="relative overflow-hidden" data-id="element-304">
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/20 rounded-full blur-3xl -z-10 translate-x-1/2 -translate-y-1/2" data-id="element-305"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-celeste-300/20 rounded-full blur-3xl -z-10 -translate-x-1/2 translate-y-1/2" data-id="element-306"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-307">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-10" data-id="element-308">
          <motion.span initial={{
          scale: 0.95
        }} whileInView={{
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block bg-red-600 text-white font-extrabold px-6 py-3 md:px-8 md:py-4 rounded-full text-lg md:text-2xl mb-8 shadow-xl shadow-red-500/30 uppercase tracking-tight" data-id="element-309">
            ¿Y si este fuera el último fin de semana que pasás así?
          </motion.span>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-stone-900 mb-6" data-id="element-310">
            EL Kit Aula de Éxitos contiene:
          </h2>

          <div className="text-2xl md:text-3xl font-bold text-stone-800 mb-4" data-id="element-311">
            6 Tomos
          </div>

          <p className="text-lg md:text-xl text-stone-600 font-medium mb-8" data-id="element-312">
            Matemática · Lengua Española · Ciencias Biológicas
          </p>

          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 md:p-8 shadow-sm border border-white inline-block" data-id="element-313">
            <p className="text-xl md:text-2xl font-bold text-stone-900" data-id="element-314">
              300 páginas - Todo resuelto. Todo alineado al EBI. Todo listo para
              usar.
            </p>
          </div>
        </motion.div>

        {/* Tomos Quick List */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mt-12" data-id="element-315">
          {[{
          id: 'Tomo 1',
          name: 'Lengua I'
        }, {
          id: 'Tomo 2',
          name: 'Lengua II'
        }, {
          id: 'Tomo 3',
          name: 'Matemática I'
        }, {
          id: 'Tomo 4',
          name: 'Matemática II'
        }, {
          id: 'Tomo 5',
          name: 'Ciencias'
        }, {
          id: 'Tomo 6',
          name: 'Evaluaciones'
        }].map((tomo, idx) => <div key={idx} className="bg-white rounded-xl p-4 shadow-sm border border-celeste-100 flex flex-col items-center justify-center text-center" data-id="element-316">
              <div className="text-xs font-bold text-celeste-600 uppercase tracking-wider mb-1" data-id="element-317">
                {tomo.id}
              </div>
              <div className="font-bold text-stone-800 text-sm" data-id="element-318">
                {tomo.name}
              </div>
            </div>)}
        </motion.div>
      </div>
    </Section>;
};